var map = {
	"./zh-CN.js": "9dzx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2PhE";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/locales nonrecursive \.js$
// module id = 2PhE
// module chunks = 19